module.exports = __webpack_public_path__ + "506e03ce6aef5bb8a1bd125e68284326.png";